module.exports = "/assets/49a3c1378326f40c4caf2f0d84f8cf4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/menu/hotels.png
// module id = 3556
// module chunks = 0